import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

export type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';
export type SpinnerContext = 'component' | 'table' | 'page' | 'inline';

@Component({
  selector: 'ces-loading-spinner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ProgressSpinnerModule],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
  readonly size = input<SpinnerSize>('md');
  readonly context = input<SpinnerContext>('component');
  readonly message = input<string>();
  readonly vertical = input(true);

  get strokeWidth(): string {
    const widths: Record<SpinnerSize, string> = {
      sm: '3',
      md: '4',
      lg: '5',
      xl: '6',
    };
    return widths[this.size()];
  }

  getSpinnerStyle(): Record<string, string> {
    const sizes: Record<SpinnerSize, { width: string; height: string }> = {
      sm: { width: '20px', height: '20px' },
      md: { width: '32px', height: '32px' },
      lg: { width: '50px', height: '50px' },
      xl: { width: '64px', height: '64px' },
    };

    return sizes[this.size()];
  }

  getContainerClasses(): string {
    const classes = ['spinner-container'];

    if (this.vertical()) {
      classes.push('vertical');
    } else {
      classes.push('horizontal');
    }

    switch (this.context()) {
      case 'page':
        classes.push('py-(--space-16)');
        break;
      case 'component':
        classes.push('py-(--space-8)');
        break;
      case 'table':
        classes.push('py-(--space-6)');
        break;
      case 'inline':
        classes.push('py-(--space-2)');
        break;
    }

    return classes.join(' ');
  }

  getMessageClasses(): string {
    const classes = ['message', this.size()];

    switch (this.context()) {
      case 'page':
      case 'component':
        classes.push('text-(color:--text-secondary)');
        break;
      case 'table':
        classes.push('text-(color:--text-secondary)');
        break;
      case 'inline':
        classes.push('text-(color:--text-primary)');
        break;
    }

    return classes.join(' ');
  }
}
